module.exports = __webpack_public_path__ + "static/media/img-heritage-area7-miikeTanko02.c047c9fb.jpg";